module.exports = __webpack_public_path__ + "img/logout.64ef82db.svg";